// Keep in sync with EDIT_WINDOW_MINUTES in bo/apps/chat/utils.py, which is
// the authority: the server rejects any edit sent past this window.
export const EDIT_WINDOW_MINUTES = 15;

export const isMessageEditable = message => {
  if (!message || !message.createdAt) {
    return false;
  }
  const createdAt = new Date(message.createdAt);
  if (Number.isNaN(createdAt.getTime())) {
    return false;
  }
  return Date.now() - createdAt.getTime() < EDIT_WINDOW_MINUTES * 60 * 1000;
};
